import PropTypes from 'prop-types';
import { sitePropType } from '../AdvancedSettings/propTypes';

export const platformPropType = PropTypes.shape({
    display_name: PropTypes.node,
    name: PropTypes.string,
});

export const appsPermissionsPropType = PropTypes.shape({
    appKeywordEnabled: PropTypes.bool,
    fraudPermitted: PropTypes.bool,
});

export const configurationPropType = PropTypes.shape({
    apsalar_enabled: PropTypes.bool,
});

export const userDataPropType = PropTypes.shape({
    attribution_enabled: PropTypes.bool,
    sdk_enabled: PropTypes.bool,
});

export const moveTargetPropType = PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    name: PropTypes.string,
});

export { sitePropType };
